import { defineStore } from 'pinia'
import { fetchData } from '@/utils/fetch'

export const useCartStore = defineStore('bestdealer-cart', () => {
  const expand = ref(true)

  const cartCount = ref(0) // 购物车数量

  const updateCartCount = async () => {
    const { code, data } = await fetchData('/appb/b2b/cart/cartCount')
    if (code === 200) {
      cartCount.value = data
    }
  }

  const toggleExpand = () => {
    expand.value = !expand.value
  }

  const setCartCount = (count) => {
    cartCount.value = count
  }

  return {
    expand,
    toggleExpand,
    cartCount,
    updateCartCount,
    setCartCount
  }
}, {
  persist: true,
  sync: true
})
